
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listing/r/[listingId]",
      function () {
        return require("private-next-pages/listing/r/[listingId]/index.tsx");
      }
    ]);
  